import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestSystemConfiguration() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/config/systemConfig",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestConfigValue(key, value) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/config/" + key,
        params: {
            field: value
        },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestSaveConfig(key, value, field) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/config/" + key,
        data: field ? { field, value } : { value },
        withCredentials: true,
        crossorigin: true
    });
}

export const requestBackupConfig = () => axios.get(`${getApiUrl()}/config/backup`, { withCredentials: true, responseType: 'blob' });

export const requestRestoreConfig = (data) => axios.post(`${getApiUrl()}/config/restore`, { data }, { withCredentials: true });

export function requestTestAIConnection(containerName, model, provider) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/config/aiConfig/test",
        data: { containerName, model, provider },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestAiUsage(days) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/ai/usage",
        params: days ? { days } : undefined,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestTestHubspotConnection() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/billing/invoices/hubspotTest",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestTestIntuitConnection() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/billing/invoices/intuitTest",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestWhatsAppStatus() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/config/whatsappConfig/status",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestWhatsAppQr() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/config/whatsappConfig/qr",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestStartWhatsAppSession() {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/config/whatsappConfig/session/start",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestLogoutWhatsAppSession() {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/config/whatsappConfig/session/logout",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestTestWhatsAppMessage(phone) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/config/whatsappConfig/test",
        data: phone ? { phone } : {},
        withCredentials: true,
        crossorigin: true
    });
}